import { useCallback } from "react";

import { Alert, alertStore } from '@/shared/store/alert';

const useAlert = () => {
  const setAlert = alertStore((state) => state.setAlert);
  const clearAlert = alertStore((state) => state.clearAlert);
  const alert = alertStore((state) => state.alert);

  const addAlert = useCallback(
    (newAlert: Alert) => {
      if (!newAlert) return;
      setAlert(newAlert);
    },
    [setAlert]
  );

  const addTwoButtonAlert = useCallback(
    (newAlert: Alert) => {
      if (!newAlert) return;
      setAlert({
        ...newAlert,
        confirmLabel: newAlert.confirmLabel || "확인", // 기본 라벨 설정
        cancelLabel: newAlert.cancelLabel || "취소", // 기본 라벨 설정
        isHTML: newAlert.isHTML ?? false,
      });
    },
    [setAlert]
  );

  const removeAlert = useCallback(() => {
    clearAlert();
  }, [clearAlert]);

  const limitLengthAlert = (limit: number, content: string) => {
    if (content.length <= limit) return true;
    addAlert({ message: "너무 길어요." });
    return false;
  };
  const deleteWarningAlert = () => {
    return new Promise((resolve) => {
      addAlert({
        message: "정말 삭제하시겠습니까?",
        onConfirm: () => resolve(null),
      });
    });
  };

  const createMessageGetter = (
    messageObject: Record<string, any>,
    defaultMessage: string = "메시지를 찾을 수 없습니다."
  ) => {
    return (
      messagePath: string,
      variables: Record<string, string> = {}
    ): string => {
      const keys = messagePath.split(".");
      let message: any = messageObject;

      // 메시지 경로 탐색
      for (const key of keys) {
        if (message[key] !== undefined) {
          message = message[key];
        } else {
          return defaultMessage;
        }
      }

      // 문자열이 아닌 경우 기본 메시지 반환
      if (typeof message !== "string") {
        return defaultMessage;
      }

      // 변수 치환
      return Object.entries(variables).reduce(
        (msg, [key, value]) => msg.replace(`\${${key}}`, value),
        message
      );
    };
  };

  return {
    alert,
    addAlert,
    addTwoButtonAlert,
    limitLengthAlert,
    deleteWarningAlert,
    removeAlert,
    createMessageGetter,
  };
};

export default useAlert;
